<template>
    <BreadCrumb PageTitle="Liste des organisations" />
    <ListeOrganisation/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue"
    import ListeOrganisation from "@/components/Organisation/ListeOrganisations.vue";
  
    export default defineComponent({
      name: "ListeOrganisationPage",
      components: {
        BreadCrumb,
         ListeOrganisation,
      },
    });
  </script>